<ng-container *ngIf="current">
  <tr class="border-dark border-top border-bottom heading font-weight-bold">
    <td colspan="4" class="text-left text-uppercase">
      <small class="pl-2 font-weight-bold heading"
        >DIAMETROS
        <small class="font-weight-bold heading text-lowercase"
          >(cm)</small
        ></small
      >
    </td>
  </tr>
  <tr-data
    *ngIf="current.biacromial"
    title="Biacromial"
    [cols]="getPropArray('biacromial')"
  ></tr-data>
  <tr-data
    *ngIf="current.transverseChest"
    title="Tórax Transverso"
    [cols]="getPropArray('transverseChest')"
  ></tr-data>
  <tr-data
    *ngIf="current.anteroposteriorChest"
    title="Tórax Anteroposterior"
    [cols]="getPropArray('anteroposteriorChest')"
  ></tr-data>
  <tr-data
    *ngIf="current.biIliocrestide"
    title="Bi-iliocrestídeo"
    [cols]="getPropArray('biIliocrestide')"
  ></tr-data>
  <tr-data
    *ngIf="current.humera"
    title="Humeral (biepicondilar)"
    [cols]="getPropArray('humera')"
  ></tr-data>
  <tr-data
    *ngIf="current.femoral"
    title="Femoral (biepicondilar)"
    [cols]="getPropArray('femoral')"
  ></tr-data>
  <tr-data
    *ngIf="current.wrist"
    title="Muñeca"
    [cols]="getPropArray('wrist')"
  ></tr-data>
  <tr-data
    *ngIf="current.ankle"
    title="Tobillo"
    [cols]="getPropArray('ankle')"
  ></tr-data>
  <tr-data
    *ngIf="current.hand"
    title="Mano"
    [cols]="getPropArray('hand')"
  ></tr-data>
</ng-container>
